<template>
  <div>
    <landing-create :content="content"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
  </div>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';
import services from '../../../services';

const { collectingInstitutionRegistry } = services;
const { collectingInstitutionService } = collectingInstitutionRegistry;

export default {
  name: 'CollectingInstitutionList',
  components: {
    ListComponent,
    LandingCreate,
  },
  data() {
    const component = this;
    return {
      service: collectingInstitutionService,
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
            {
              text: 'Date updated',
              column: 'dateUpdated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Name',
            value: 'name',
          },
          {
            text: 'Description',
            value: 'description',
          },
          {
            text: 'Created by',
            value: '_metadata.created.user.fullName',
          },
          {
            text: 'Date created',
            value: '_metadata.created.date',
          },
          {
            text: 'Actions',
            value: 'actions',
          },
        ],
        URLName: 'collecting-institution',
        actionDisplay: {
          delete: {
            visible: true,
            icon: () => 'mdi-delete-empty',
          },
        },
        onClickArchive(item) {
          component.onArchive(item);
        },
      },
      content: {
        pageTitle: 'Collecting Institution',
        commands: [
          {
            link: 'collecting-institution.create',
            icon: 'mdi-plus-box',
            buttonName: 'Create',
          },
        ],
      },
    };
  },
  methods: {
    async onArchive(item) {
      this.isLoading = true;
      try {
        await collectingInstitutionService.archive({ collectingInstitution: item });
        this.$snackbar.show({
          text: 'Successfully deleted collected insitution!',
          closeColor: 'white',
          color: 'green',
        });
      } catch (e) {
        console.log('catch', e);
        const { message } = e.response.data;
        this.$snackbar.show({ color: 'red', text: message, closeColor: 'white' });
      }
      this.isLoading = false;
    },
  },
};
</script>
